import React from "react"
import gql from "graphql-tag"

import {Mutation} from "../../mutation"

export const insGlobalMutation = gql`
  mutation InsGlobalMutation($params: InsGlobalParams) {
    insGlobal(params: $params) @client
  }
`

const UpdateInsGlobal = ({children, ...props}) => {
  return (
    <Mutation {...props} mutation={insGlobalMutation}>
      {(mutate, apolloState) => {
        return children(
          (...args) => mutate(...args),
          apolloState
        )
      }}
    </Mutation>
  )
}


export default UpdateInsGlobal
